import { cn } from "@/lib/utils";

export function ErrorIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-4.5 w-[15px] text-bright-red", className)}
      fill="none"
      viewBox="0 0 15 18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        fill="currentColor"
        r="7.5"
        transform="matrix(0 1 1 0 7.5 10.5)"
      />
      <path
        d="M5.258 8.258l4.381 4.381m0-4.381l-4.382 4.381"
        opacity="0.6"
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="1.564"
      />
    </svg>
  );
}
